module.exports = __webpack_public_path__ + "static/media/8.b9176d16.jpg";